import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CustomSelect from '../components/CustomSelect';
import CulturesForm from '../components/SettingsForms/Cultures';
import { getDepth } from '../helpers/core';
import appConfig from "../config/app";

class UsersExportForm extends Component {
	constructor (props) {
		super(props);
		this.state = {
			exportForm: {
				category: '',
				showSuccess: false,
				showError: false
			},
			settingsForm: {
				messageShowed: false,
				error: null,

				km_price: getDepth(['selectData', 'settings', 'km_price'], this.props) || 0,
				price_valid_days: getDepth(['selectData', 'settings', 'price_valid_days'], this.props) || 0,
				min_profit: getDepth(['selectData', 'settings', 'min_profit'], this.props) || 1000,
				min_delivery_price: getDepth(['selectData', 'settings', 'min_delivery_price'], this.props) || 300,
				near_distance: getDepth(['selectData', 'settings', 'near_distance'], this.props) || 800,
				card_days_in_work: getDepth(['selectData', 'settings', 'card_days_in_work'], this.props) || 21,
				limit_of_cards_in_work: getDepth(['selectData', 'settings', 'limit_of_cards_in_work'], this.props) || 20
			},
			culturesForm: {
				messageShowed: false,
				error: null
			},
			marginForm: {
				category: ''
			}
		};
	}

	componentWillReceiveProps (nextProps) {
		const { clearMessages } = nextProps;

		if (nextProps.exportLink) {
			window.open(nextProps.exportLink, '_blank');
			this.props.clearExportLink();
			this.setState({
				exportForm: {
					category: ''
				}
			})
		}

		if (nextProps.messageShowed !== this.props.messageShowed) {
			const { form, error, text } = nextProps.alertData;
			this.setState(prevState => ({
				[form]: {
					...prevState[form],
					messageShowed: nextProps.messageShowed,
					text: error || text,
					type: error ? 'danger' : 'success'
				}
			}), () => {
				if (nextProps.messageShowed) {
					// скрываем сообщение через 3 секунды
					setTimeout(() => { clearMessages() }, 2000);
				}
			});
		}
	}

	changeStateValues = (name, value, formName) => {
		const additionState = {};

		if (formName === 'marginForm' && name === 'category') {
			additionState.culture = '';
			additionState.percent = '';
			additionState.coefficient = '';
		}

		if (formName === 'marginForm' && name === 'culture') {
			additionState.percent = this.props.filteredCultures.find(culture => culture.value == value).margin;
			additionState.coefficient = this.props.filteredCultures.find(culture => culture.value == value).km_price;
		}

		if (value !== null) additionState[name] = value;

		this.setState(prevState => ({
			[formName]: {
				...prevState[formName],
				...additionState
			}
		}));
	}

	handleExport = (e) => {
		e.preventDefault();

		this.props.onExportClick(this.state.exportForm.category);
	}

	handleInputChange = (e) => {
		const value = e.target.value;
		const form = e.target.dataset.form;
		const field = e.target.dataset.field;
		this.changeStateValues(field, value, form);
	}

	saveSettingHandler = (e) => {
		e.preventDefault();

		let all_settings = {...this.state.settingsForm};
		delete all_settings['error'];
		delete all_settings['messageShowed'];

		this.props.saveSettingValue(all_settings);
		this.changeStateValues('coefficient', null, 'settingsForm');
	}

	isActiveIntegration = appConfig.isActivePoleplanIntegration.toString() !== '0';

	render () {
		const { selectData, saveCulture, deleteCulture } = this.props;
		const { settingsForm, culturesForm } = this.state;
		const categoriesForExport = [{label: 'Без категории', value: -1}, ...selectData.categories];

		return (
			<div>
				<CulturesForm deleteCulture={deleteCulture} saveCulture={saveCulture} alertData={culturesForm} />

				<div className="row">
					<div className="col-md-12">
						<h3>Настройки расчетов</h3>
					</div>
					{settingsForm.messageShowed ?
						<div className={`alert alert-${settingsForm.type} col-xs-12`}>
							{settingsForm.type === 'success' ? settingsForm.text : settingsForm.error}
						</div> : null
					}
					<div className="col-md-3">
						<h4>Транспортный коэффициент</h4>
						<form className="custom-form" ref={c => this.settingsForm = c}>

							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.km_price}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="km_price"
									/>
								</div>
							</div>
						</form>
					</div>
					<div className="col-md-3">
						<h4>Минимальная маржа, руб.</h4>
						<form className="custom-form">
							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.min_profit}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="min_profit"
									/>
								</div>
							</div>
						</form>
					</div>
					<div className="col-md-3">
						<h4>Минимальная доставка, руб</h4>
						<form className="custom-form">
							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.min_delivery_price}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="min_delivery_price"
									/>
								</div>
							</div>
						</form>
					</div>
					<div className="col-md-3">
						<h4>Актуальность цены, дни</h4>
						<form className="custom-form">
							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.price_valid_days}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="price_valid_days"
									/>
								</div>
							</div>
						</form>
					</div>
					<div className="col-md-3">
						<h4>Радиус поиска поставщиков, км</h4>
						<form className="custom-form">
							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.near_distance}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="near_distance"
									/>
								</div>
							</div>
						</form>
					</div>
					<div className="col-md-3">
						<h4>Длительность статуса карточки "В Работе", дней</h4>
						<form className="custom-form">
							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.card_days_in_work}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="card_days_in_work"
									/>
								</div>
							</div>
						</form>
					</div>
					<div className="col-md-3">
						<h4>Максимум карточек "В Работе"</h4>
						<form className="custom-form">
							<div className="clearfix mr-bottom-20">
								<div className="pull-left mr-right-20">
									<label className="custom-form__label">Показатель</label>
									<input
										type="text"
										value={this.state.settingsForm.limit_of_cards_in_work}
										className="custom-form__input custom-form__input--small"
										onChange={this.handleInputChange}
										data-form="settingsForm"
										data-field="limit_of_cards_in_work"
									/>
								</div>
							</div>
						</form>
					</div>

					<div className="col-md-12">
						<button
							className="btn btn-success pull-right"
							type="submit"
							onClick={this.saveSettingHandler}
						>
							Сохранить настройки
						</button>
					</div>
				</div>

				<h4 hidden={!this.isActiveIntegration}>Экспорт данных</h4>
				<div className="clearfix" hidden={!this.isActiveIntegration}>
					<form className="custom-form" ref={c => this.exportForm = c}>
						<div className="pull-left mr-right-20">
							<label className="custom-form__label">Категория</label>
							<CustomSelect
								name="category"
								options={categoriesForExport}
								placeholder="Выберите категорию"
								values={this.state.exportForm.category}
								onSelect={this.changeStateValues}
								formName="exportForm"
								multiple
							/>
						</div>
						<div className="cols-with-no-label pull-left">
							<button
								className="btn btn-success"
								type="submit"
								onClick={this.handleExport}
								disabled={!this.state.exportForm.category}
							>
								Экспорт
							</button>
						</div>
					</form>
				</div>
			</div>
		);
	}
}

UsersExportForm.propTypes = {
	selectData: PropTypes.object,
	onExportClick: PropTypes.func.isRequired,
	exportLink: PropTypes.string,
	clearExportLink: PropTypes.func.isRequired,
	saveSettingValue: PropTypes.func.isRequired,
	alertData: PropTypes.object,
	messageShowed: PropTypes.bool,
	filteredCultures: PropTypes.array,
	clearMessages: PropTypes.func.isRequired,
	deleteCulture: PropTypes.func.isRequired,
	saveCulture: PropTypes.func.isRequired
}

export default UsersExportForm;



// WEBPACK FOOTER //
// ./components/UsersExportForm.js